import { addressToString } from '@debbie/common/dist/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import SearchInput from '../../../SearchInput.js';
const CourtSelector = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement("div", null,
        React.createElement(SearchInput, { placeholder: lang.documents.selectCourt, searchAll: (q) => {
                return props.courts
                    .filter((c) => `${c.name}${c.address}${c.city}${c.email}${c.phone}`
                    .toLowerCase()
                    .indexOf(q.toLowerCase()) !== -1)
                    .map((c) => ({
                    key: c.id,
                    heading: c.name,
                    subheading: addressToString(c),
                    returnData: c,
                }));
            }, static: props.value?.name, onRemoveStatic: () => {
                props.onChange(null);
            }, onSelect: (court) => {
                props.onChange(court);
            }, searchDelay: 0, forceOpen: true })));
};
export default CourtSelector;
//# sourceMappingURL=CourtSelector.js.map